export default __webpack_public_path__ + "static/media/wrench.2f9055ca.svg";